var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4196_8844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 6.66634C12.5871 6.66634 13.3333 5.92015 13.3333 4.99967C13.3333 4.0792 12.5871 3.33301 11.6667 3.33301C10.7462 3.33301 10 4.0792 10 4.99967C10 5.92015 10.7462 6.66634 11.6667 6.66634Z",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 5H9.9987",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 5H16.6654",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 11.6663C7.58714 11.6663 8.33333 10.9201 8.33333 9.99967C8.33333 9.0792 7.58714 8.33301 6.66667 8.33301C5.74619 8.33301 5 9.0792 5 9.99967C5 10.9201 5.74619 11.6663 6.66667 11.6663Z",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 10H4.9987",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 10H16.6654",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 16.6663C15.0871 16.6663 15.8333 15.9201 15.8333 14.9997C15.8333 14.0792 15.0871 13.333 14.1667 13.333C13.2462 13.333 12.5 14.0792 12.5 14.9997C12.5 15.9201 13.2462 16.6663 14.1667 16.6663Z",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 15H12.4987",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.832 15H16.6654",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4196_8844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.41a3707cfe43a1b1f8c6b7276bd7e644.svg";
export { ForwardRef as ReactComponent };